<template>
    <div class="notebook-main">
        <div class="notebook_header" :v-if="showHeader">
            <Button icon="md-cloud-upload" @click="Save" :disabled="!saveButtonShow" title="保存"></Button>
            <Button icon="md-add" @click="AddLine" title="新增"></Button>
            &nbsp;
            <ButtonGroup>
                <Button icon="md-cut" @click="Cut" title="剪切"></Button>
                <Button icon="md-copy" @click="Copy" title="复制"></Button>
                <Button icon="ios-copy" @click="Paste" title="粘贴"></Button>
            </ButtonGroup>
            &nbsp;
            <ButtonGroup>
                <Button icon="md-arrow-round-up" @click="Up" title="上移"></Button>
                <Button icon="md-arrow-round-down" @click="Down" title="下移"></Button>
            </ButtonGroup>
            &nbsp;
            <buttonGroup>
                <Button icon="md-skip-forward" @click="Run" title="运行"></Button>
                <Button icon="md-fastforward" @click="RunAll" title="运行所有"></Button>
<!--                <Button icon="md-square" @click="Interrupt" title="中断"></Button>-->

            </buttonGroup>
            <!--                            <buttonGroup>-->
            <!--                                <Button icon="md-construct" @click="SetUrl"></Button>-->
            <!--                            </buttonGroup>-->
            <buttonGroup>
                <Select @on-change="SelectType" v-model="cellType">
                    <Option v-for="item in cellTypeList" :value="item" :key="item">{{ item }}</Option>
                </Select>
            </buttonGroup>


            <buttonGroup class="run-status">
                <div v-if="percent !== 100">
                    <Progress :percent="percent">
                        <span>{{progressTxt}}</span>
                    </Progress>
                </div>
                <div v-else>
                    <CountDown :endTime="endTime" v-if="endTime != '' && percent==100" :lab-id="jupyter_contest_lab_id" :storage-prefix="storage_prefix" :contest-id="contestInfo.id" :agent-url="contestInfo.mcp_endpoint.domain_name" :call-func="showDestruct" style="float:left;"></CountDown>
    <!--                <Button size="small" @click="SetUrl" v-if="!isConnect">连接</Button>-->
    <!--                <Button size="small" @click="Shutdown" v-if="isConnect">断开</Button>-->
                    <span class="kernerl-name">{{kernelName}}</span>
                    <font-awesome-icon :icon="['fas','circle']" :style="{ color: runColor }" />
                </div>
            </buttonGroup>
        </div>
        <div id="cm-jupyterlab"></div>
    </div>
</template>
<script>
    import common from './common/mixins'
    import CountDown from './common/countdown'
    import cookie from 'vue-cookies'
    import "@/assets/js/cm-nb/cm-nb"

    export default {
        name:"Jupyter",
        props:{
            fileUuid:{
                type:String,
                required:true
            },
            contestInfo:{
                type:Object,
                required:true
            },
            treeListFunc:{
                type:Function,
                default:function () {}
            },
            contentType:{
                type:String,
                default:'contest',
            }
        },
        components:{
            CountDown
        },
        mixins: [common],
        data(){
            return {
                percent:10,
                progressTxt:"加载中...",
                tree_list:[],
                saveButtonShow:true,
                destructShow:false, // 销毁容器弹窗
                showHeader:false,   // jp button 显示
                isConnect:false,
                kernelName:'',
                runColor:"gray",
                cellType:"",
                cellTypeList:[],
            }
        },
        methods:{
            SetUrl(address){
                console.log("设置url:"+address);
                var _this = this;
                // 设置执行代码容器
                this.cmNBManager.setBaseUrl(address);

                // 获取容器内核
                this.cmNBManager.getSpecs().then(
                    s => {
                        console.log(s);

                        _this.cmNBManager.changeKernel({name: "python3"}).then(s =>{
                            console.log(s);
                            _this.isConnect = true;
                        }).catch(e => console.log(e))
                    }
                ).catch(e => console.log(e))


            },
            Shutdown(){
                var _this = this;
                this.cmNBManager.shutdown().then(function () {
                    _this.isConnect = false;
                    console.log("shutdown");
                }).catch(e=>{
                    console.log(e)
                });
            },
            Save(){
                this.saveButtonShow = false;
                this.cmNBManager.save()
            },
            AddLine(){
                this.cmNBManager.insertBelow()
            },
            Cut(){
                this.cmNBManager.cutCell()
            },
            Copy(){
                this.cmNBManager.copyCell()
            },
            Paste(){
                this.cmNBManager.pasteCell()
            },
            Up(){
                this.cmNBManager.moveUpCell()
            },
            Down(){
                this.cmNBManager.moveDownCell()
            },
            Run(){
                this.cmNBManager.runAdvance()
            },
            RunAll(){
                this.cmNBManager.runAll()
            },
            Interrupt(){
                this.cmNBManager.interrupt()
            },
            SelectType(value){
                this.cmNBManager.changeCellType(value)
            },
            // 显示销毁信息
            showDestruct(ok){
                if(ok){
                    this.destructShow = true;
                }else{
                    this.$Message.error("容器销毁异常");
                }
            },
        },
        created(){
            console.log("JpId:"+this.jupyter_contest_lab_id);
            console.log("FileUuid:"+this.fileUuid);
            let _this = this;
            //jp 先创建个出来
            this.cellTypeList = window.CMCellTypeList;
            let baseUrl = window.ILAB_COMMON_CONF.kernelBaseUrl;
            let contentUrl = "";
            if(_this.contentType == 'correct'){
                contentUrl = window.ILAB_COMMON_CONF.kernelContentMarkUrl;
            }else{
                contentUrl = window.ILAB_COMMON_CONF.kernelContentUrl;
            }
            let accessToken = cookie.get('session');
            let noteBookID = this.fileUuid + '.ipynb';
            let element = "cm-jupyterlab";
            this.cmNBManager = new window.CMNBManager(baseUrl, contentUrl, accessToken, noteBookID, element);
            this.cmNBManager.ready().then(() => {
                this.showHeader = true;
                this.cmNBManager.createNB(this.cmNBManager.serviceManager);
                this.cmNBManager.onStatusChanged(statusChanged);
                this.cmNBManager.onKernelNameChanged(KernelNameChanged);
                this.cmNBManager.onCellTypeChanged(cellTypeChanged);
                this.cmNBManager.onSaveChanged(saveChanged);
                // 获取目录
                setTimeout(setTree,2000);
                var NB = this.cmNBManager;
                function setTree(){
                    var nbHeadings = NB.getNBHeadings();
                    _this.treeListFunc(nbHeadings);
                }


                if(this.jupyter_contest_lab_id == null || this.jupyter_contest_lab_id == undefined ){
                    this.getLabApply(this.contestInfo.mcp_endpoint.domain_name,this.contestInfo.id);
                }else{
                    this.getLabQuery(this.contestInfo.mcp_endpoint.domain_name);
                    this.HeartbeatInterval(this.contestInfo.mcp_endpoint.domain_name);
                }


            }).catch(err => {
                console.log(err)
            });

            function statusChanged(sessionContext) {
                const status = sessionContext.kernelDisplayStatus;
                if (sessionContext) {
                    console.log(status);
                    switch(status){
                        case window.CMKernelStatus.SPACE:
                        case window.CMKernelStatus.UNKNOWN:
                        {
                            _this.runColor = "red";
                            _this.isConnect = false;
                            break;
                        }
                        case window.CMKernelStatus.IDLE:
                        {
                            if (_this.cmNBManager.getKernelName() == "No Kernel"){
                                _this.runColor = "blue";
                                break;
                            }
                            _this.runColor = "green";
                            _this.isConnect = true;
                            break;
                        }
                        case window.CMKernelStatus.BUSY:
                        {
                            _this.runColor ="yellow";
                            _this.isConnect = true;
                            break;
                        }
                        case window.CMKernelStatus.STARTING:
                        case window.CMKernelStatus.AUTORESTARTING:
                        case window.CMKernelStatus.CONNECTED:
                        case window.CMKernelStatus.CONNECTING:
                        case window.CMKernelStatus.INITIALIZING:
                        {
                            _this.runColor = "blue";
                            _this.isConnect = false;
                            break;
                        }
                        case window.CMKernelStatus.DEAD:
                        case window.CMKernelStatus.DISCONNECTED:
                        {
                            _this.runColor = "black";
                            _this.isConnect = false;
                            break;
                        }
                    }
                } else {
                    console.log("sessionContext is null")
                }
            }

            function cellTypeChanged() {
                if (_this.cmNBManager.nbWidget.content.activeCell) {
                    const value = _this.cmNBManager.nbWidget.content.activeCell.model.type;
                    console.log("function cellTypeChanged(nbPanel) > ", value);
                    _this.cellType = value
                }
            }

            function saveChanged(context,saveState) {
                console.log("function saveChanged(Context > ", context);
                console.log("function saveChanged(SaveState > ", saveState);
                if (saveState === 'started') {
                    console.log("(saveState === 'started')");
                    // 获取所有标头信息
                    var nbHeadings = _this.cmNBManager.getNBHeadings();
                    _this.treeListFunc(nbHeadings)
                }else if(saveState === 'completed'){
                    _this.saveButtonShow = true;
                    console.log("(saveState === 'completed')");
                }else if(saveState === 'failed'){
                    _this.saveButtonShow = true;
                    _this.$Message.error("保存失败");
                    console.log("(saveState === 'failed')");
                }
            }

            function KernelNameChanged() {
                console.log("function KernelNameChanged()");
                console.log("this.cmManager.getKernelName() > ", _this.cmNBManager.getKernelName());
                _this.kernelName = _this.cmNBManager.getKernelName()
            }

        },
        watch:{
            'jupyter_contest_lab_id':{
                handler:function(val){
                    this.HeartbeatInterval();
                },
                immediate: true
            }
        }
    }
</script>
<style scoped>
    /*notebook*/
    .notebook-main{
        padding-left:2px;
        height:100%;
    }
    #cm-jupyterlab{
        position:relative;
        width:100%;
        max-width: 1122px;
        min-height:1px;
        height:94%;
        margin: auto;

    }
    .notebook_header{
        padding-top:3px;
        width: 100%;
        margin: auto;
        border-bottom: 1px solid #ddd;

    }
    .run-status{
        /*border-left: 1px solid;*/
        float:right;
        margin-left: 5px;
        margin-right: 5px;
        width:auto;
    }
    .kernerl-name{
        padding-left:5px;
        padding-right:5px;
    }
</style>
